import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black py-16 px-4 border-t border-zinc-900" data-id="element-42">
      <div className="max-w-4xl mx-auto text-center" data-id="element-43">
        <p className="font-['Crimson_Text'] text-base md:text-lg text-zinc-500 leading-relaxed" data-id="element-44">
          Descarga inmediata tras el pago. Optimizado para lectura en móviles y
          tablets.
        </p>
      </div>
    </footer>;
}